export const mapStudentIdsFromGroups= (groups) => {
  const filteredStudentIds = Object.values(groups).reduce((accumulator, group) => {
    const { students: studentIds = [] } = group || {};

    return accumulator.concat(studentIds);
  }, []);

  return [...new Set(filteredStudentIds)];
};

export default mapStudentIdsFromGroups;
